module.exports = __webpack_public_path__ + "media/fonts/Oricons-a40e3238363b966813571d226028223a.woff2";